import React from "react";
import Box from "@mui/material/Box";
import {Grid, Typography} from "@mui/material";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import {Link} from "react-router-dom";

const Events = () => {
    return (
        <Box>
            <Box sx={{marginTop: 4}}>
                <Typography variant="h4">Events</Typography>
            </Box>
            <Box sx={{marginTop: 4}}>
                <Grid container spacing={{xs: 1, sm: 1, md: 2, lg: 3, xl: 4}}
                      columns={{xs: 2, sm: 2, md: 4, lg: 4, xl: 4}}>
                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                        <Card>
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: "red"}} aria-label="recipe">
                                        TO
                                    </Avatar>
                                }
                                title="Tolaria Online: March of the Machine"
                                subheader="NIEDZIELA, 112023 9:30 – 19:00"
                            />
                            <CardMedia
                                component="img"
                                height="194"
                                image="https://guildmage.pl/images/tolaria-online-mom.jpg"
                                alt="Paella dish"
                            />
                            <CardContent>
                                <Typography variant="body2" color="text.secondary">
                                    Tolaria Online jest wydarzeniem mającym na celu wyróżnienie polskich graczy Limited
                                    w cyfrowych wersjach gry Magic: the Gathering.
                                    Najlepsi gracze na platformach MTG Arena oraz MTG Online spotkają we wspólnym
                                    turnieju współzawodnicząc o tytuł Najlepszego Polskiego Gracza Limited w bieżącym
                                    formacie. Tym razem polem zmagań będzie draft March of the Machine!
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" component="a"
                                        href="https://app.easycart.pl/checkout/50766280/tolaria-online-march-of-the-machine"
                                        target="_blank">Kup Bilet</Button>
                                <Button size="small" component={Link} to={"/shop/events/tolaria"}>Czytaj więcej</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>

                <Box height={48}/>
            </Box>
        </Box>

    )
}

export default Events;
